import { MarketBasket } from '@qv-bid/entities';

export class MarketBasketModalOutput {
  constructor(public marketBasket?: MarketBasket, public isAddedToOtherScenarios: boolean = false) {}
}
